import LogoSvg from '@/assets/wntd-wordmark-orange.svg';

interface PollShareCardProps {
  title: string;
  images?: string[];
  userName?: string;
}

export function PollShareCard({ title, images, userName }: PollShareCardProps) {
  const displayImages = images?.slice(0, 4) || [];
  
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#0a0a0a',
        padding: '48px 48px 40px',
      }}
    >
      {/* Images grid */}
      <div
        style={{
          flex: 1,
          display: 'grid',
          gridTemplateColumns: displayImages.length > 1 ? '1fr 1fr' : '1fr',
          gridTemplateRows: displayImages.length > 2 ? '1fr 1fr' : '1fr',
          gap: 16,
          borderRadius: 32,
          overflow: 'hidden',
        }}
      >
        {displayImages.length > 0 ? (
          displayImages.map((img, index) => (
            <div
              key={index}
              style={{
                position: 'relative',
                backgroundColor: '#1a1a1a',
                borderRadius: 24,
                overflow: 'hidden',
              }}
            >
              <img
                src={img}
                alt={`Option ${index + 1}`}
                crossOrigin="anonymous"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
              {/* Vote indicator */}
              <div
                style={{
                  position: 'absolute',
                  top: 20,
                  left: 20,
                  width: 48,
                  height: 48,
                  borderRadius: '50%',
                  backgroundColor: 'rgba(0,0,0,0.6)',
                  backdropFilter: 'blur(10px)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 24,
                  fontWeight: 700,
                  color: 'white',
                }}
              >
                {index + 1}
              </div>
            </div>
          ))
        ) : (
          <div
            style={{
              width: '100%',
              height: '100%',
              background: 'linear-gradient(135deg, #FF5C4D 0%, #FF6F3B 100%)',
              borderRadius: 24,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <span
              style={{
                fontSize: 64,
                fontWeight: 700,
                color: 'white',
              }}
            >
              ?
            </span>
          </div>
        )}
      </div>

      {/* Caption/Question */}
      <div
        style={{
          paddingTop: 40,
          paddingBottom: 20,
        }}
      >
        {title && (
          <p
            style={{
              fontSize: 36,
              fontWeight: 600,
              color: 'white',
              lineHeight: 1.3,
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {title}
          </p>
        )}
        {userName && (
          <p
            style={{
              fontSize: 24,
              color: 'rgba(255,255,255,0.5)',
              marginTop: 12,
              fontWeight: 500,
            }}
          >
            by @{userName}
          </p>
        )}
      </div>

      {/* Footer with branding */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingTop: 20,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <img
            src={LogoSvg}
            alt="WNTD"
            style={{ height: 36 }}
          />
          <span
            style={{
              fontSize: 24,
              color: '#FF6F3B',
              fontWeight: 600,
            }}
          >
            Vote on WNTD
          </span>
        </div>
        <span
          style={{
            fontSize: 24,
            color: 'rgba(255,255,255,0.4)',
            fontWeight: 400,
          }}
        >
          wntd.ai
        </span>
      </div>
    </div>
  );
}
